














import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { ParagraphSize } from '@getaccept/lib-ui';
import type { DsrResource } from '@getaccept/lib-shared/src/library/types/dsr-resource';

export default defineComponent({
  name: 'LastUsedCard',
  props: {
    template: {
      type: Object as PropType<DsrResource>,
      required: true,
    },
  },
  setup() {
    return {
      ParagraphSize,
    };
  },
});
